import { Injectable, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root',
})
export class PushNotificationService {
	private http = inject(HttpClient);
	private configService = inject(ConfigService);

	private get baseUrl() {
		return this.configService.configuration.apiUrl;
	}

	public initPush() {
		if (Capacitor.isNativePlatform()) {
			this.registerPush();
		}
	}

	private registerPush() {

		PushNotifications.addListener('registration', (token: Token) => {
			console.log('Push registration success, token: ' + token.value);
			this.registerTokenOnBackend(token.value);
		});

		PushNotifications.addListener('registrationError', (error: any) => {
			console.error('Error on push registration: ' + JSON.stringify(error));
		});

		PushNotifications.addListener('pushNotificationReceived', (notification: any) => {
			console.log('Push received: ' + JSON.stringify(notification));
		});

		PushNotifications.addListener('pushNotificationActionPerformed', (notification: any) => {
			console.log('Push action performed: ' + JSON.stringify(notification));
		});

    PushNotifications.requestPermissions().then((result) => {
			if (result.receive === 'granted') {
				PushNotifications.register();
			}
		});
	}

	private registerTokenOnBackend(token: string) {
		const deviceType = Capacitor.getPlatform().toUpperCase();
		console.log('Registering token on backend with type ' + deviceType);
		console.log('Token: ' + token);

		// Il token viene inviato al backend tramite l'endpoint registerToken
		this.http.post(this.baseUrl + '/api/user/registerToken', { token, deviceType }).subscribe({
			next: () => console.log('Token successfully registered on backend with type ' + deviceType),
			error: (err) => {
				const errorMessage = err.error ? JSON.stringify(err.error) : err.message;
				console.error('Error registering token on backend. Status: ' + err.status + ' | Details: ' + errorMessage);
			}
		});
	}
}
